import React, { useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IPreferences } from "@/logic/api";
import NotchedCard from "@/components/cards/NotchedCard/NotchedCard";
import EditableGroup, { EditableGroupType } from "@/components/editable/EditableGroup/EditableGroup";
import EditableField, { EditableFieldTypes } from "@/components/editable/EditableField/EditableField";
import { SessionContext } from "@/utility/useSession";
import { isSysAdmin } from "@/utility/utils";
import styles from "../../styles";

interface NoticePeriodSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const NoticePeriodSettings: React.FC<NoticePeriodSettingsProps> = ({ onSave }) => {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    if (!session.current.site) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard
                label={t("settings.collectionDelivery.title")}
                containerProps={{ "data-testid": "notice-period-settings-card" }}
                style={styles.card}
            >
                <EditableGroup<IPreferences>
                    id="noticePeriodSettings"
                    editType={EditableGroupType.switchableEditing}
                    data={session.current.site.preferences}
                    onDataChanged={(data) => onSave({
                        collectionNotice: data.collectionNotice ?? undefined,
                        deliveryNotice: data.deliveryNotice ?? undefined,
                    })}
                    testId="notice-period-settings"
                >
                    <Grid container>
                        <EditableField<IPreferences, number>
                            testId="settings-arrival-notice-mins-field"
                            inputType={EditableFieldTypes.number}
                            label={t("settings.collectionDelivery.arrivalNotice")}
                            onProvide={(data) => data.collectionNotice ?? 0}
                            onChange={(data, value) => {
                                data.collectionNotice = value || undefined;
                            }}
                        />
                        <EditableField<IPreferences, number>
                            testId="settings-return-notice-mins-field"
                            inputType={EditableFieldTypes.number}
                            label={t("settings.collectionDelivery.returnNotice")}
                            onProvide={(data) => data.deliveryNotice ?? 0}
                            onChange={(data, value) => {
                                data.deliveryNotice = value || undefined;
                            }}
                        />
                    </Grid>
                </EditableGroup>
            </NotchedCard>
        </Grid>
    );
};
